import { useMatch } from "react-router-dom";

export type TabType = "workspaces" | "rooms" | "explore";

export const useHereAndNowTab = () => {
  const match = useMatch("/now/:tab");
  const tab = match?.params?.tab ?? "unknown";

  return tab as TabType | "unknown";
};
